<template>
  <div :class="type" class="flash">
    <slot>
      <span class="body-text--sm-regular">{{ flashText }}</span>
    </slot>
    <slot name="actions">
      <a v-if="flashAction" class="flash--action body-text--sm-regular" @click.prevent="flashAction">Undo</a>
    </slot>
  </div>
</template>

<script>
export default {
  name: "Flash",
  props: {
    flashAction: {
      type: Function
    },
    flashText: {
      type: String,
      required: true,
    },
    flashType: {
      type: String,
      default: "alert"
    }
  },
  computed: {
    type() {
      return `flash--${this.flashType}`;
    }
  },
}
</script>

<style lang="scss" scoped>
  @import "~StyleguideAssets/scss/master.scss";
</style>